<template>
  <div>
    <div class="app-title">
      <em-view-title ref="emViewTitle" v-bind:crudState="$_emWorkflowTaskMixin_pathType"></em-view-title>
    </div>
    <section class="app-content">
      <div id="entity-viewer" class="content" v-menu-permission="'list'">
        <div class="card">
          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
               data-parent="#accordionFilter">
            <div class="card-body">
              <em-workflow-business-data-editor :entity="modelName"
                                                :business-data="$_emWorkflowTaskMixin_businessData">
              </em-workflow-business-data-editor>
            </div>
          </div>
        </div>
      </div>
      <WorkflowProcessLine :processDefinitionKey="$_emWorkflowTaskMixin_processDefinitionKey"
                           :config="config"
                           ref="processExecution"
                           @gotItems="setLocalVariables"
                           :businessKey="$_emWorkflowTaskMixin_businessKey">
      </WorkflowProcessLine>
      <div id="em-workflow-task-complete" class="content" v-if="$_emWorkflowTaskMixin_isShowTaskComplete">
        <WorkflowTaskComplete ref="processComplete" :task-id="$_emWorkflowTaskMixin_taskId"
                              :businessKey="$_emWorkflowTaskMixin_businessKey"
                              :status="$_emWorkflowTaskMixin_businessData.status"
                              :callbackApi="$_emWorkflowTaskMixin_callbackApi"
                              :config="config">
        </WorkflowTaskComplete>
      </div>
    </section>
  </div>
</template>
<script>
// Author SWL
// Date 2022-03-31 18:13:36

import emWorkflowTaskMixin from "@/mixin/em/workflow/task";
import WorkflowTaskComplete from "@/components/workflow/stuffs/WorkflowTaskComplete";
import workflowTaskMixins from "@/components/workflow/mixin/WorkflowTaskMixins";
import WorkflowProcessLine from "@/components/workflow/stuffs/WorkflowProcessLine";

export default {
  name: "emArchToolChangeWorkflowTaskView",
  mixins: [emWorkflowTaskMixin, workflowTaskMixins],
  components: {WorkflowProcessLine, WorkflowTaskComplete},
  computed: {
    modelName() {
      return this.$_emRouterHelperMixin_entityName
    },
    $_emWorkflowTaskMixin_callbackApi() {
      return this.$store.state.emArchToolChange.baseModuleUrl + "/emArchToolChange/complete-feedback";
    },
    config() {
      return {
        'submit': {
          name: '操作工添加明细确认',
          variables: [
            {
              label: '流程管理',
              type: this.VALUE_TYPE.SELECT,
              saveTo: this.SAVE_TO.APPROVE,
              options: [
                  {value: 1, text: '提交'},
                  {value: 2, text: '撤销'}
              ],
            },
            {
              label: '备注',
              name: 'remark',
              type: this.VALUE_TYPE.TEXTAREA,
              saveTo: this.SAVE_TO.DATABASE,
              initData: true,
            }
          ],
          approveToNextTask: {
            1: 'warehouse_manager',
            2: 'End'
          },
          postByApprove: (approve) => {
              return {
                url: this.$store.state.emArchToolChange.baseModuleUrl + `/emArchToolChange/doAfterSubmit?toolChangeId=${this.$_emWorkflowTaskMixin_businessKey}&approvedStatus=${approve}`,
                data: {}
              };
          },
        },
        'warehouse_manager': {
          name: '库管员',
          approveLabel: '是否同意',
          approveToNextTask: {
            1: 'End',
            2: 'submit'
          },
          withAttachment: true,
          withComment: true,
          postByApprove: (approve) => {
            return {
              url: this.$store.state.emArchToolChange.baseModuleUrl + `/emArchToolChange/doAfterWarehouseManagerApproved?toolChangeId=${this.$_emWorkflowTaskMixin_businessKey}&approvedStatus=${approve}`,
              data: {}
            };
          },
        },
        'End': {
          name: '结束'
        },
      }
    }
  }
};
</script>